import { Stack } from '@mantine/core';

type MobileOptimizedProps = {
  children: React.ReactNode;
};

// Component for mobile-first content layout
export const MobileOptimized = ({ children }: MobileOptimizedProps) => {
  return (
    <Stack
      gap="md"
      px={{ base: 'xs', sm: 'md' }}
      pt={{ base: 'md', sm: 'lg' }}
    >
      {children}
    </Stack>
  );
};
